import { Injectable } from '@angular/core';

export interface LatLng {
  lat: number;
  lng: number;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleService {

  constructor() {}

  async getDrivingDistance(origin: LatLng, destination: LatLng): Promise<number> {
    return new Promise((resolve, reject) => {
      const service = new google.maps.DistanceMatrixService();

      const originCoord = new google.maps.LatLng(origin.lat, origin.lng);
      const destinationCoord = new google.maps.LatLng(destination.lat, destination.lng);

      service.getDistanceMatrix(
        {
          origins: [originCoord],
          destinations: [destinationCoord],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC, // Distancia en metros
        },
        (response: google.maps.DistanceMatrixResponse | null, status: google.maps.DistanceMatrixStatusString) => {
          if (status === 'OK' && response) {
            try {
              const distanceMeters = response.rows[0].elements[0].distance.value; // Distancia en metros
              const distanceMiles = distanceMeters * 0.000621371; // Convertir a millas
              resolve(distanceMiles);
            } catch {
              reject('Error al obtener la distancia');
            }
          } else {
            reject('Error en el servicio de Distance Matrix');
          }
        },
      );
    });
  }

  initAutocomplete(inputElement: HTMLInputElement, callback: (place: google.maps.places.PlaceResult) => void) {
    const autocomplete = new google.maps.places.Autocomplete(inputElement, {
      types: ['geocode','establishment'],
      //componentRestrictions: { country: 've' },
      //language: 'es',
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      callback(place);
    });
  }

  getPredictions(query: string): Promise<google.maps.places.AutocompletePrediction[]> {

    const autocompleteService = new google.maps.places.AutocompleteService();
    
    return new Promise((resolve) => {
      if (!query || query.length < 3) return resolve([]);

      autocompleteService.getPlacePredictions({
        input: query,
        types: ['geocode', 'establishment']
        // componentRestrictions: { country: 've' } // Si quieres limitar a Venezuela
      }, (predictions: google.maps.places.AutocompletePrediction[] | null, status: google.maps.places.PlacesServiceStatusString) => {
        if (status === 'OK' && predictions) {
          resolve(predictions);
        } else {
          resolve([]);
        }
      });
    });

  }

  getPlaceDetails(placeId: string): Promise<google.maps.places.PlaceResult> {

    const placesService = new google.maps.places.PlacesService(document.createElement('div'));

    return new Promise((resolve, reject) => {
      placesService.getDetails({ placeId: placeId }, (place: google.maps.places.PlaceResult | null, status: google.maps.places.PlacesServiceStatusString) => {
        if (status === 'OK' && place) {
          resolve(place);
        } else {
          reject('Error obteniendo detalles');
        }
      });
    });

  }

}
